import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function ajaxCounterReducer(state = initialState.ajaxCounter, action) {
	switch (action.type) {
		case types.AJAX_CALL_STARTED:
			return state + 1;

		case types.AJAX_CALL_ENDED:
			if (state > 0)
				return state - 1;

			return state;

		case types.AJAX_CALL_FAILED:
			if (state > 0)
				return state - 1;

			return state;

		default:
			return state;
	}
}